import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-call-for-papers24',
  templateUrl: './call-for-papers.component.html',
  styleUrls: ['./call-for-papers.component.css']
})
export class CallForPapersComponent24 implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
